export const speakingConfig = {
  testType: 'speaking',
  
  global: {
    recordingTimeLimit: 'no-limit',
    showPrePartInstructions: true,
    showPostPartInstructions: false
  },
  
  parts: {
    'part-1': {
      waitingTime: 5,
      preInstructions: [
        {
          id: 'part1-pre-1',
          title: 'Part 1: Introduction & Interview',
          content: 'In this part, the examiner will ask you general questions about yourself and familiar topics such as your home, family, work, studies, and interests.\n\nThis part typically lasts 4-5 minutes.',
          type: 'info'
        }
      ],
      postInstructions: []
    },
    
    'part-2': {
      waitingTime: 60,
      preInstructions: [
        {
          id: 'part2-pre-1',
          title: 'Part 2: Individual Long Turn (Cue Card)',
          content: 'In this part you will be given a topic and you have 1-2 minutes to talk about it.\n\nBefore you talk, you have 1 minute to think about what you\'re going to say, and you can make some notes if you wish.',
          type: 'info'
        }
      ],
      postInstructions: []
    },
    
    'part-3': {
      waitingTime: 5,
      preInstructions: [
        {
          id: 'part3-pre-1',
          title: 'Part 3: Two-way Discussion',
          content: 'In this part, the examiner will ask you more complex questions related to the Part 2 topic.\n\nYou will discuss more abstract ideas and issues. This part typically lasts 4-5 minutes.',
          type: 'info'
        }
      ],
      postInstructions: []
    }
  }
};

export default speakingConfig;
